document.querySelectorAll(".custom-select__option").forEach((el) => {
  const swatchColor = el.getAttribute("data-swatch");
  el.style.setProperty("--swatch-color", swatchColor);
});

document.querySelectorAll('.custom-select__listbox').forEach(li=>{
    li.addEventListener('click', function(){
      let color = event.target.dataset.color;

      setTimeout(()=>{

        document.querySelectorAll(".custom-select__btn").forEach(ele=>{
          const swatchColor = ele.getAttribute("data-swatch");
          ele.style.setProperty("--swatch-color", swatchColor);
        })


        
      }, 150);
      
      
      
    })
})